import "./svg/nav-home-filled.svg"

export default {
    name: "nav-home-filled",
    viewBox: "24 24",
}
